import { useCloseOnEscape } from "hooks/useCloseOnEscape";
import { useTranslation } from "react-i18next";
import {
  CloseButton,
  HeaderRow,
  HiddenRadio,
  Overlay,
  Panel,
  RadioControl,
  RadioGroup,
  RadioLabel,
  RadioOption,
  Section,
  SectionDescription,
  SectionTitle,
  Title,
} from "./staffOptionsPanel.styled";

export type StaffGroupByOption = "person" | "team";

interface StaffOptionsPanelProps {
  isOpen: boolean;
  groupByOption: StaffGroupByOption;
  onGroupByChange: (value: StaffGroupByOption) => void;
  onClose: () => void;
}

/**
 * Handles staff options panel.
 */
export const StaffOptionsPanel = (
  props: StaffOptionsPanelProps,
): JSX.Element | null => {
  const { t } = useTranslation();

  useCloseOnEscape({
    isOpen: props.isOpen,
    onClose: props.onClose,
    stopPropagation: true,
  });

  if (!props.isOpen) return null;

  return (
    <Overlay onClick={props.onClose}>
      <Panel onClick={(event) => event.stopPropagation()}>
        <HeaderRow>
          <Title>{t("Staff.Options")}</Title>
          <CloseButton
            iconName="v2/cross"
            size="small"
            aria-label={t("DesignComponents.CloseModal")}
            onClick={props.onClose}
          />
        </HeaderRow>
        <Section>
          <SectionTitle>{t("Staff.GroupBy")}</SectionTitle>
          <SectionDescription>
            {t("Staff.GroupByDescription")}
          </SectionDescription>
          <RadioGroup role="radiogroup" aria-label={t("Staff.GroupBy")}>
            <RadioOption>
              <HiddenRadio
                type="radio"
                name="staff-group-by"
                checked={props.groupByOption === "team"}
                onChange={() => props.onGroupByChange("team")}
              />
              <RadioControl />
              <RadioLabel>{t("Staff.Team")}</RadioLabel>
            </RadioOption>
            <RadioOption>
              <HiddenRadio
                type="radio"
                name="staff-group-by"
                checked={props.groupByOption === "person"}
                onChange={() => props.onGroupByChange("person")}
              />
              <RadioControl />
              <RadioLabel>{t("Staff.Person")}</RadioLabel>
            </RadioOption>
          </RadioGroup>
        </Section>
      </Panel>
    </Overlay>
  );
};
